import React from 'react';
import { withRouter } from 'react-router-dom';
import SVGTrash from '../../svg/Trash.js';
import ServiceSelectedDishes from './ServiceSelectedDishes';
import ServiceMenuCTAs from './ServiceMenuCTAs';
import { maskServiceWeek, maskLiveDate, maskRichText } from '../../masks';
import { isOccasion } from '../../helpers/serviceUtil';

class ServiceMenu extends React.Component {
  render() {
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Menu</h3>
          </div>
          <div className="cms__bar-right">
            {this.renderEditButton()}
            {this.renderSaveButton()}
          </div>
        </div>
        <div className="cms__section-body">
          {this.renderMenuView()}
          {this.renderMenuEdit()}
          {this.renderAddButton()}
          {this.renderSelectedDishes()}
        </div>
      </div>
    );
  }

  renderEditButton = () => {
    if (!this.props.isEdit && this.props.service.menu)
      return (
        <span className="a--blue" onClick={this.openEdit}>
          Edit
        </span>
      );
  };

  renderSaveButton = () => {
    if (this.props.isEdit && this.props.service.menu)
      return (
        <span className="a--blue" onClick={this.closeEdit}>
          Preview
        </span>
      );
  };

  renderAddButton = () => {
    if (!this.props.service.menu)
      return (
        <div
          className="btn btn--white btn--full-width"
          onClick={this.props.openMenuModal}
        >
          + Add Menu
        </div>
      );
  };

  renderMenuView = () => {
    if (!this.props.isEdit && this.props.service.menu) {
      if (this.props.service.service_type === 'weekly') {
        return this.renderWeeklyMenuView();
      } else if (isOccasion(this.props.service)) {
        return this.renderOccasionMenuView();
      }
    }
  };

  renderWeeklyMenuHeader = () => {
    return (
      <div className="p row row--space-between row--pad row--border-bottom">
        <div className="row__item row__item--fifth p--bold">Name</div>
        <div className="row__item row__item--sixth p--bold">Service Week</div>
        <div className="row__item row__item--sixth p--bold">Live On</div>
        <div className="row__item row__item--fourth p--bold">Notes</div>
        <div className="row__item row__item--fifth p--bold"> </div>
      </div>
    );
  };

  renderOccasionMenuHeader = () => {
    return (
      <div className="p row row--space-between row--pad row--border-bottom">
        <div className="row__item row__item--fourth p--bold">Name</div>
        <div className="row__item row__item--fourth p--bold">Notes</div>
        <div className="row__item row__item--fourth"> </div>
        <div className="row__item row__item--tenth"> </div>
        <div className="row__item row__item--tenth"> </div>
        <div className="row__item row__item--twentieth"> </div>
      </div>
    );
  };

  renderWeeklyMenuView = () => {
    const { name, notes, service_week } = this.props.service.menu;
    return (
      <div>
        {this.renderWeeklyMenuHeader()}
        <div className="p row row--space-between row--pad">
          <div className="row__item row__item--fifth">{name || ''}</div>
          <div className="row__item row__item--sixth">
            {maskServiceWeek(service_week)}{' '}
          </div>
          <div className="row__item row__item--sixth">
            {maskLiveDate(service_week)}
          </div>
          <div className="row__item row__item--fourth">
            {maskRichText(notes || '')}
          </div>
          <div className="row__item row__item--fifth"> </div>
        </div>
      </div>
    );
  };

  renderOccasionMenuView = () => {
    const { name, notes } = this.props.service.menu;
    return (
      <div>
        {this.renderOccasionMenuHeader()}
        <div className="p row row--space-between row--pad">
          <div className="row__item row__item--fourth">{name || ''}</div>
          <div className="row__item row__item--fourth">
            {maskRichText(notes || '')}
          </div>
          <div className="row__item row__item--fourth"> </div>
          <div className="row__item row__item--tenth" />
          <div className="row__item row__item--tenth"> </div>
          <div className="row__item row__item--twentieth" />
        </div>
      </div>
    );
  };

  renderMenuEdit = () => {
    if (this.props.isEdit && this.props.service.menu) {
      if (this.props.service.service_type === 'weekly') {
        return this.renderWeeklyMenuEdit();
      } else if (isOccasion(this.props.service)) {
        return this.renderOccasionMenuEdit();
      }
    }
  };

  renderWeeklyMenuEdit = () => {
    const { name, notes, service_week } = this.props.service.menu;
    return (
      <div>
        {this.renderWeeklyMenuHeader()}
        <div className="p row row--space-between row--bordered">
          <div className="row--bordered__item row__item--fifth">
            {name || ''}
          </div>
          <div className="row__item row__item--sixth">
            {maskServiceWeek(service_week)}
          </div>
          <div className="row--bordered__item row__item--sixth">
            {maskLiveDate(service_week)}
          </div>
          <div className="row--bordered__item row__item--fourth">
            {maskRichText(notes || '')}
          </div>
          <div className="row--bordered__item row__item--fifth">
            <a className="a--blue" onClick={this.linkSelectDishes}>
              Select Dishes
            </a>
          </div>
        </div>
      </div>
    );
  };

  renderOccasionMenuEdit = () => {
    const { name, notes } = this.props.service.menu;
    return (
      <div>
        {this.renderOccasionMenuHeader()}
        <div className="p row row--space-between row--bordered">
          <div className="row__item row__item--fourth">{name || ''}</div>
          <div className="row__item row__item--fourth">
            {maskRichText(notes || '')}
          </div>
          <div className="row__item row__item--fourth"> </div>
          <div className="row__item row__item--tenth">
            <a className="a--blue" onClick={this.linkSelectDishes}>
              Select Dishes
            </a>
          </div>
          <div className="row__item row__item--tenth"> </div>
          <div className="row__item row__item--twentieth">
            <span
              className="btn-icon btn-icon--trash"
              onClick={this.deleteMenu}
            >
              <SVGTrash />
            </span>
          </div>
        </div>
      </div>
    );
  };

  renderSelectedDishes = () => {
    // uncomment this if we want to hide selected dishes and the buttons when there are no selections
    // if(this.props.menuSelections.length === 0) return '';
    return (
      <div className="cms__subsection">
        <ServiceSelectedDishes
          isEdit={this.props.isEdit}
          setServiceUnsaved={this.props.setServiceUnsaved}
          service={this.props.service}
          updateService={this.props.updateService}
          updateMenuSelections={this.props.updateMenuSelections}
          menuSelections={this.props.service.menu_selections || []}
          menu={this.props.service.menu || {}}
        />
        <ServiceMenuCTAs
          isEdit={this.props.isEdit}
          openDishModal={this.props.openDishModal}
          openGroceryList={this.props.openGroceryList}
          serviceID={this.props.service.id}
        />
      </div>
    );
  };

  openEdit = () => {
    this.props.updateService({}, { isMenuEdit: true });
  };

  closeEdit = () => {
    this.props.updateService({}, { isMenuEdit: false });
  };

  deleteMenu = () => {
    this.props.updateService({ menu: null });
  };

  linkSelectDishes = () => {
    const { service } = this.props;
    this.props.setServiceUnsaved(false, () =>
      this.props.history.push({
        pathname: '/admin/service/dish-selection',
        state: {
          service,
          redirect_url: this.props.match.url,
          redirect_payload: { service }
        }
      })
    );
  };
}

export default withRouter(ServiceMenu);



// WEBPACK FOOTER //
// ./src/components/service/ServiceMenu.js